import React from "react";
import { STYLE_TYPE } from "../../../config/constants";
import blockHTML from "../../../utils/blockHTML";

export const styleToHTML = style => {
  switch (style.toLowerCase()) {
    case STYLE_TYPE.BOLD:
      return <strong />;

    case STYLE_TYPE.ITALIC:
      return <em />;

    default:
      return <span />;
  }
};

export const blockToHTML = (
  extras,
  isClient,
  headerLevels,
  isPrimary
) => block => {
  const html = blockHTML[block.type.toLowerCase()];

  switch (typeof html) {
    case "undefined":
      return blockHTML["default"];

    case "function":
      return html(block, extras, isClient, headerLevels, isPrimary);

    default:
      return html;
  }
};
